import config from 'src/config';
import Http from 'src/helpers/httpClient';

const END_POINT = 'v1/coupons';

export const COUPON_END_POINT = {
  NEW_USER: `${END_POINT}/new-user`,
};

export default {
  createNewUser(data: { recaptchaResponse: string; email: string }) {
    const apiUrl = `${config.API_DOMAIN}/${COUPON_END_POINT.NEW_USER}`;
    return Http.post(apiUrl, data);
  },
};
